const overrideCollapse = (theme) => {
  theme.overrides.MuiCollapse = {
    root: {
      width: '100%'
    }
  };
};

export default overrideCollapse;
